module.exports = __webpack_public_path__ + "media/images/emblems/Moenchaltorf-blazon-521e1623ddb26d3dd08988c43c65f78c.svg";